/**
 * Regex patterns for validating paintwork-related number formats
 */

/**
 * Lakbon number pattern
 * Format: L followed by exactly 6 digits (e.g., "L046203")
 * Database stores lakbon IDs with the "L" prefix
 */
export const LAKBON_PATTERN = /^L\d{6}$/;

/**
 * Lakwerkorder (paintwork order) number pattern
 * Format: LAK followed by one or more digits (e.g., "LAK12345")
 */
export const LAKWERKORDER_PATTERN = /^LAK\d+$/;
